<template>
  <v-container>
    <v-card class="card-container">
      <v-tabs v-model="tab" color="deep-purple-accent-4" align-tabs="center">
        <v-tab value="one">Import From Url</v-tab>
        <v-tab value="two">Import From Excel</v-tab>
        <v-tab value="three">Rest Users</v-tab>
        <v-tab value="four">Hide/Unhide Users</v-tab>

      </v-tabs>

      <!-- <v-card-text> -->
      <v-window v-model="tab" class="window-container">
        <v-window-item value="one">
          <span> import </span>
        </v-window-item>

        <v-window-item value="two">
          <v-file-input
            @change="onChange"
            @click:clear="onClear"
            show-size
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            label="File input"
          ></v-file-input>

          <div>
            Number of users: {{ fileInfo.usersNumber }},
            <!-- <template> -->
            <div>
              <span>existedCount</span>
              <v-progress-linear
                v-model="importExcelStatus.existedCount"
                :max="fileInfo.usersNumber"
                color="blue-grey"
                height="25"
              >
                <!-- <template v-slot:default="{ value }"> -->
                <strong>{{
                  importExcelStatus.existedCount ? importExcelStatus.existedCount : 0
                }}</strong>
                <!-- </template> -->
              </v-progress-linear>

              <br />
              <span>createdCount:</span>

              <v-progress-linear
                v-model="importExcelStatus.createdCount"
                :max="fileInfo.usersNumber"
                color="blue-grey"
                height="25"
              >
                <!-- <template v-slot:default="{ value }"> -->
                <strong>{{
                  importExcelStatus.createdCount ? importExcelStatus.createdCount : 0
                }}</strong>

                <!-- </template> -->
              </v-progress-linear>
              <br />
            </div>
            <!-- </template> -->
          </div>

          <v-btn @click="importUsersFromExcelHandler" :disabled="excelData.length == 0">
            import
          </v-btn>
        </v-window-item>

        <v-window-item value="three">
          <h2>Reset Users [ {{ userFrom }} ]</h2>
          <v-row>
            <v-col cols="8">
              <v-select
                clearable
                chips
                label="Users Added From"
                :items="usersFrom"
                v-model="userFrom"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-dialog v-model="dialog" persistent width="auto">
                <template v-slot:activator="{ props }">
                  <v-btn
                    color="primary"
                    v-bind="props"
                    style="width: fit-content"
                    :disabled="userFrom == null"
                  >
                    Reset
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    Are you sure you want to reset {{ userFrom }} users ?
                  </v-card-title>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green-darken-1" variant="text" @click="dialog = false">
                      No
                    </v-btn>
                    <v-btn color="green-darken-1" variant="text" @click="confirmHandler">
                      Yes
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item value="four">
          <h2>Hide/Unhide Users [ {{ hideUserFrom }} ]</h2>
          <v-row>
            <v-col cols="8">
              <v-select
                clearable
                chips
                label="Users Added From"
                :items="hideUsersFrom"
                v-model="hideUserFrom"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-dialog v-model="dialog" persistent width="auto">
                <template v-slot:activator="{ props }">
                  <v-btn
                    color="primary"
                    v-bind="props"
                    style="width: fit-content"
                    :disabled="hideUserFrom == null"
                    @click="hideUnhideAction = 'hide'"
                  >
                    Hide
                  </v-btn>

                  <v-btn
                    color="primary"
                    v-bind="props"
                    style="width: fit-content"
                    :disabled="hideUserFrom == null"
                    @click="hideUnhideAction = 'unhide'"
                  >
                    Unhide
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    Are you sure you want to {{ hideUnhideAction }}  {{ hideUserFrom }} users ?
                  </v-card-title>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green-darken-1" variant="text" @click="dialog = false">
                      No
                    </v-btn>
                    <v-btn color="green-darken-1" variant="text" @click="confirmHideUnhideHandler">
                      Yes
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-window-item>

      </v-window>
      <!-- </v-card-text> -->
    </v-card>
  </v-container>
</template>

<style scoped>
.card-container {
  box-shadow: none;
  height: 80vh;
}
.window-container {
  padding: 20px;
}
</style>

<script>
import repository from '../../api/repository'

import * as XLSX from 'xlsx'
import { mapState, mapActions } from 'pinia'
import { useGlobalStore } from '../../stores/global'
import { useUserStore } from '../../stores/user'
// [matrah] toasts
import { toastSuccess, toastError, toastWarning, toastInfo, toastApiError } from '../../utils/notify'

export default {
  name: 'UsersSettingView',
  components: {},

  data: () => ({
    tab: null,
    dialog: false,
    usersFrom: ['all', 'excel_sheet', 'url', 'api', 'conversation'],
    userFrom: null,
    hideUsersFrom: ['excel_sheet', 'url', 'api', 'conversation'],
    hideUserFrom:null,
    hideUnhideAction:null,
    responseMsgs: [],
    file: null,
    fileInfo: {
      size: 0,
      usersNumber: 0,
    },
    importExcelStatus: {
      existedCount: 0,
      createdCount: 0,
    },
    importUrlStatus: {
      existedCount: 0,
      createdCount: 0,
    },
    excelData: [],
  }),
  computed: {
    ...mapState(useGlobalStore, ['notifications']),
  },
  methods: {
    ...mapActions(useGlobalStore, ['setNotify', 'setNotifications', 'appendNotifications']),
    ...mapActions(useUserStore, ['setIsUsersUpdated']),

    async importUsersFromUrlHandler() {
      const usersUrl = ''; //process.env.VUE_APP_USERS_API;
      // [matrah] legacy: const res = await repository.create('users/import-url', { url: `${usersUrl}` })
      let res
      try {
        res = await repository.create('users/import-url', {
          url: `${usersUrl}`,
        })
      } catch (error) {
        toastApiError(error, 'Import from URL failed')
        return
      }
      toastSuccess('Import from URL started — contacts are being added in the background.')
      console.log({
        res
      })
      this.setNotifications(res.data.messages)
      this.importUrlStatus.existedCount += res?.data?.existedCount
      this.importUrlStatus.createdCount += res?.data?.createdCount

      if (this.importUrlStatus.createdCount > 0) {
        this.setIsUsersUpdated()
      }
      this.setNotify()

      console.log({
        res,
      })
    },

    async importUsersFromExcelHandler() {
      // [matrah] toasts: nothing to import / per-run totals / failure (stops at the failing chunk)
      if (!this.excelData.length) {
        toastWarning('Choose an Excel file with at least one row (name, phone) first.')
        return
      }
      const createdBefore = this.importExcelStatus.createdCount
      const existedBefore = this.importExcelStatus.existedCount
      const chunkSize = 100
      for (let idx = 0; idx < this.excelData.length; idx += chunkSize) {
        const chunk = this.excelData.slice(idx, idx + chunkSize)
        console.log({
          chunk,
          idx,
          t: idx === 0,
        })

        // [matrah] legacy: const res = await repository.create('users/import', { data: chunk })
        let res
        try {
          res = await repository.create('users/import', { data: chunk })
        } catch (error) {
          const done = this.importExcelStatus.createdCount - createdBefore
          toastApiError(error, done ? `Excel import stopped after ${done} new number(s)` : 'Excel import failed')
          return
        }

        // this.responseMsgs.push(...res.data.data)

        // await this.$store.dispatch('SET_LOGGER', this.responseMsgs)
        if (idx === 0) {
          console.log('setNotifications')
          this.setNotifications(res.data.data.messages)
        } else {
          console.log('appendNotifications')

          this.appendNotifications(res.data.data.messages)
        }
        this.importExcelStatus.existedCount += res.data.data.existedCount
        this.importExcelStatus.createdCount += res.data.data.createdCount

        if (this.importExcelStatus.createdCount > 0) {
          this.setIsUsersUpdated()
        }

        this.setNotify()

        console.log({
          res,
        })
      }
      // [matrah]
      const created = this.importExcelStatus.createdCount - createdBefore
      const existed = this.importExcelStatus.existedCount - existedBefore
      toastSuccess(`Excel import finished: ${created} new number(s) added, ${existed} already existed.`)
    },
    onClear() {
      console.log('onClear')
      this.fileInfo.usersNumber = 0
      this.excelData = []
    },
    async onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null
      if (this.file) {
        console.log({
          wb: this.file,
        })
        this.fileInfo.size = this.file.size
        const reader = new FileReader()

        reader.onload = async (e) => {
          /* Parse data */
          const bstr = e.target.result
          // [matrah] legacy: const wb = XLSX.read(bstr, { type: 'binary' }) (a non-Excel file threw an uncaught error)
          let wb
          try {
            wb = XLSX.read(bstr, { type: 'binary' })
          } catch (error) {
            this.excelData = []
            this.fileInfo.usersNumber = 0
            toastError('This file could not be read. Please choose an Excel file (.xlsx / .xls / .csv).')
            return
          }
          /* Get first worksheet */
          const wsname = wb.SheetNames[0]
          const ws = wb.Sheets[wsname]
          /* Convert array of arrays */
          this.excelData = XLSX.utils.sheet_to_json(ws, { header: 1 })
          this.excelData.shift()
          console.log({
            data: this.excelData,
            wb: this.file,
          })

          this.excelData.forEach((item) => {
            console.log({ is0: item[0] !== undefined, is1: item[1] !== undefined })
          })
          this.excelData = this.excelData.filter((item) => {
            return item[0] !== undefined && item[1] !== undefined
          })
          this.fileInfo.usersNumber = this.excelData.length
          // [matrah]
          if (this.excelData.length) toastInfo(`${this.excelData.length} row(s) ready to import.`)
          else toastWarning('No valid rows found (each row needs a name and a phone number).')
        }
        // [matrah]
        reader.onerror = () => toastError('Could not read the selected file.')
        reader.readAsBinaryString(this.file)
        this.file = null
      }
    },
    async confirmHandler() {
      this.dialog = false
      if (this.userFrom) {
        // [matrah] legacy: const res = await repository.create('users/reset', { added_from: this.userFrom })
        let res
        try {
          res = await repository.create('users/reset', { added_from: this.userFrom })
        } catch (error) {
          toastApiError(error, 'Reset failed')
          return
        }
        toastSuccess(typeof res?.data?.data === 'string' ? res.data.data : 'Contacts reset.')
        // this.responseMsgs.push(res.data.data)
        // await this.$store.dispatch('SET_LOGGER', this.responseMsgs)
        this.setNotifications([res.data.data])
        this.setIsUsersUpdated()
        console.log({ res })
        this.setNotify()
      }
    },

     async confirmHideUnhideHandler() {
      this.dialog = false
      if (this.hideUserFrom) {
        // [matrah] legacy: const res = await repository.hideUnhideFrom(this.hideUnhideAction, this.hideUserFrom)
        let res
        try {
          res = await repository.hideUnhideFrom(this.hideUnhideAction, this.hideUserFrom)
        } catch (error) {
          toastApiError(error, this.hideUnhideAction === 'unhide' ? 'Unhide failed' : 'Hide failed')
          return
        }
        toastSuccess(typeof res?.data?.message === 'string' && res.data.message ? res.data.message : this.hideUnhideAction === 'unhide' ? 'Contacts shown again.' : 'Contacts hidden.')
        this.setNotifications([res.data.message])
        this.setIsUsersUpdated()
        console.log({ res })
        this.setNotify()
      }
    },
  },

  async updated() {},
  async created() {
    console.log('users | created')
  },
  async mounted() {
    console.log('users')
  },
}
</script>
